import {Component, OnInit} from "@angular/core";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {
    ProductAmount,
    ProductAmountsV1Service,
    Department,
    ToastLevel,
    WoodType,
    Barrel, TaskType, ProductTypesV1Service, ProductTypeLookup
} from "../../../apis/backend";
import {
    BehaviorSubject,
    debounceTime,
    distinctUntilChanged,
    filter,
    firstValueFrom, from, mergeMap,
    Observable,
    OperatorFunction
} from "rxjs";
import {o} from "odata";

@Component({
    selector: 'product-amount-dialog',
    templateUrl: './product-amount-dialog.component.html',
})
export class ProductAmountDialogComponent implements OnInit {

    public ProductTypeValues: ProductTypeLookup[];
    public ProductTypesLoaded = new BehaviorSubject<boolean>(false);

    public ProductAmount: ProductAmount = <ProductAmount>{};
    public IsNew: boolean = false;
    
    constructor(
        public ActiveModal: NgbActiveModal,
        public ProductTypeApiService: ProductTypesV1Service) {

        firstValueFrom(this.ProductTypeApiService.getProductTypes())
            .then(productTypes => {
                this.ProductTypeValues = productTypes;
                this.ProductTypesLoaded.next(true);
            });
    }
    
    ngOnInit() {
        this.IsNew = !this.ProductAmount.ProductAmountID;
        
        this.ProductTypesLoaded.subscribe({
            next: async (loaded) => {
                if (loaded) {
                    // TODO: Define the default more explicitly.
                    this.ProductAmount.ProductType = this.ProductAmount.ProductType || this.ProductTypeValues[0];
                    await this.RecalculateID();
                }
            }
        });
    }
    
    public async RecalculateID() {
        if (!this.IsNew || !this.ProductAmount.ProductType) {
            return;
        }
        
        this.ProductAmount.ProductAmountID = await firstValueFrom(this.ProductTypeApiService
            .getNextProductAmountIDForProductType(this.ProductAmount.ProductType.ProductTypeID));
    }

    public CompareProductTypes(productType1: ProductTypeLookup, productType2: ProductTypeLookup) {
        return productType1?.ProductTypeID == productType2?.ProductTypeID;
    }

    public BarrelSearch: OperatorFunction<string, readonly Barrel[]> = (searchTerm: Observable<string>) => searchTerm.pipe(
        debounceTime(200),
        distinctUntilChanged(),
        filter(term => term.length >= 1),
        mergeMap(term => {
            return from(o('/', { credentials: "include" })
                .get('odata/barrels')
                .fetch({
                    $filter: 'contains(Name, \'' + term.replace("'", "''") + '\')',
                    $top: 10
                })
                .then(response => {
                    return (<any>response).json();
                })
                .then(odata => {
                    return odata.value;
                }));
        })
    );

    public FormatBarrel(barrel: Barrel) {
        return barrel.Name;
    }

    public ParseDate(dateStr: string) {
        return new Date(dateStr);
    }
    
    public Save() {
        this.ActiveModal.close(this.ProductAmount);
    }
    
    public Cancel() {
        this.ActiveModal.dismiss();
    }
}